import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  requested: false,
  received: false,
  error: null,
  newToken: null
};

const refreshTokenSlice = createSlice({
  name: 'auth/refreshToken',
  initialState,
  reducers: {
    setTokenState: (state, action) => ({
      ...state,
      ...action.payload
    })
  },
  extraReducers: {}
});

export const { setTokenState } = refreshTokenSlice.actions;

export default refreshTokenSlice.reducer;
